import React from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";
import SportCode from "components/common/SportCode";
import Status from "components/presentation/Status";
import Sprites from "styles/images/SpriteIcons.svg";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getDateTimeFormat } from "helpers/utils";

export function CompetitorBlockNoData(competitor) {
    return (
        <div className=' d-flex flex-row justify-content-start'>
            <div className=''>
                {competitor?.cp_code !== 'TBD'
                    ? <SportCode discipline={'FEN'} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} />
                    : ''
                }
            </div>
        </div>
    )
}

export function Footer({ data }) {
    const { mirs_discipline } = useUrlFriendlyToParameters();
    const locationCode = data?.schedule?.location?.code ? data?.schedule?.location?.code : '';
    let color
    let locationDescription
    const red = <SportCode entity='@Colour' code='RED' />
    const yellow = <SportCode entity='@Colour' code='YELLOW' />
    const blue = <SportCode entity='@Colour' code='BLUE' />
    const green = <SportCode entity='@Colour' code='GREEN' />
    if (mirs_discipline === 'FEN') {
        color = locationCode === 'FEB' ? blue : locationCode === 'FER' ? red : locationCode === 'FEG' ? green : locationCode === 'FEY' ? yellow : undefined
        locationDescription = data?.schedule?.location?.shortDescription
    }
    else if (mirs_discipline === 'WFE') {
        color = locationCode.slice(0, 2) === 'WB' ? blue : locationCode.slice(0, 2) === 'WR' ? red : locationCode.slice(0, 2) === 'WG' ? green : locationCode.slice(0, 2) === 'WY' ? yellow : undefined
        locationDescription = data?.schedule?.location?.shortDescription
    }
    let colorCode = color?.props?.code
    const piste = color && (<svg className='mirsIcon' style={{ fill: colorCode }}><use xlinkHref={`${Sprites}#square`} /></svg>)

    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status  justify-content-end'><Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} /></div>}
            {isLessLiveStatus(data?.result?.status?.code) && (
                <div className='d-flex justify-content-between w-100'>
                    <div className='text-start w-50'>{dateComponent}</div>
                    <div className='text-end w-50'>{locationDescription} {piste}</div>
                </div>
            )
            }

        </>
    )
}

export function CompetitorBlock(competitor) {
    let bold = competitor?.result === undefined || competitor?.cp_wlt === 'W' || competitor?.cp_wlt === 'V(T)' ? 'fw-bold' : ''
    const isTeam = competitor?.participant?.__typename === 'Team'

    return (
        <div className={'score-competitor-container  d-flex flex-row justify-content-start ' + bold}>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} showImgAlt={isTeam ? false : true} />
            </div>
            <div className='score-name'><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} showSeed={true} seed={competitor?.co_seed} medicalClass={false} onlyShortName={true} screen={competitor.screen} /> </div>
        </div>
    )
}
